export const sensorFragment = `
uniform vec3 uColor;
uniform sampler2D tDepth;
uniform float cameraNear;
uniform float cameraFar;
uniform vec2 resolution;
uniform float uHatchScale;
uniform vec3 uHatchColor;
uniform float uHatchStrength;
uniform vec2 uCenter;
uniform float uProjRadius;
uniform vec3 uGlowColor;
uniform float uGlowStrength;
varying vec3 vNormal;
varying float vViewZ;

float linearizeDepth(float d) {
    float z = d * 2.0 - 1.0;
    return (2.0 * cameraNear * cameraFar) / (cameraFar + cameraNear - z * (cameraFar - cameraNear));
}

void main() {
    vec2 uv = gl_FragCoord.xy / resolution; // 0..1 across canvas
    float sceneD = texture2D(tDepth, uv).x;
    float sceneViewZ = linearizeDepth(sceneD);
    float sensorZ = vViewZ;

    vec3 base = uColor;
    float alpha = 1.0;

    // occlusion test (sensor is behind scene geometry)
    bool occluded = sensorZ > sceneViewZ + 0.001;

    vec3 colorOut = base;

    if (occluded) {
        vec2 coord;
        if (uProjRadius > 0.0001) {
            coord = (gl_FragCoord.xy - uCenter) / uProjRadius;
        } else {
            vec2 center = resolution * 0.5;
            float fallbackRadius = min(resolution.x, resolution.y) * 0.25;
            coord = (gl_FragCoord.xy - center) / fallbackRadius;
        }

        vec2 p = (coord * uHatchScale);
        vec2 tp = fract(p) - 0.5;
        float d = abs(tp.x) + abs(tp.y);
        float diamond = 1.0 - smoothstep(0.45, 0.5, d);

        vec3 tint = uHatchColor * uHatchStrength;
        colorOut = mix(colorOut, colorOut + tint, diamond);
        alpha *= diamond;
    } else {
        float facing = abs(dot(normalize(vNormal), vec3(0.0, 0.0, 1.0)));
        float fresnel = pow(1.0 - facing, 2.0);
        float zFactor = clamp(1.0 / (0.01 * vViewZ + 0.001), 0.0, 3.0);
        float glow = fresnel * uGlowStrength;
        colorOut += uGlowColor * glow;
    }

    colorOut = clamp(colorOut, 0.0, 1.0);
    gl_FragColor = vec4(colorOut, alpha);
}
`;

export default sensorFragment;
